import { type FC } from "react";
import { MenuItem, Stack } from "@mui/material";
import { useIntl } from "react-intl";
import RefreshIcon from "@mui/icons-material/Refresh";

import TwoLineDropdownItem from "@/components/dropdown/two-line-dropdown-item";

import { useReclosePackagingSolution } from "../hooks/use-reclose";

interface RecloseMenuItemProps {
	readonly internalUniqueId: string;
}

export const RecloseMenuItem: FC<RecloseMenuItemProps> = ({ internalUniqueId }) => {
	const { reclose } = useReclosePackagingSolution(internalUniqueId);
	const intl = useIntl();
	return (
		<MenuItem onClick={reclose}>
			<Stack direction="row" alignItems="center" spacing={2}>
				<RefreshIcon sx={{ fontSize: 24 }} />
				<TwoLineDropdownItem
					primaryText={intl.formatMessage({ id: "Re-Close", defaultMessage: "Re-Close" })}
					secondaryText={intl.formatMessage({
						id: "Re-induct carton to close again",
						defaultMessage: "Re-induct carton to close again",
					})}
				/>
			</Stack>
		</MenuItem>
	);
};
